import { apiClient } from '@/services/ApiClient.js'

export class JobBoardService {
  getJobBoards(query) {
    return apiClient
      .get('job-boards', {
        params: query
      })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }

  getJobBoard(jobBoard) {
    return apiClient
      .get('job-boards/' + jobBoard)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }

  createJobBoard(jobBoard) {
    return apiClient
      .post('job-boards', jobBoard)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }

  updateJobBoard(id, jobBoard) {
    return apiClient
      .patch('job-boards/' + id, jobBoard)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }

  deleteJobBoard(id) {
    return apiClient
      .delete('job-boards/' + id)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }
}
